/**
 * The overview's two-column split, shared by the page and its placeholder
 * (spec 079 FR-016).
 *
 * Named here rather than written inline in both places, because a placeholder that
 * restates this grid is a second copy of it: the breakpoint, the rail width and the two
 * gaps would all have to be changed twice, and nothing fails when only one of them is —
 * the placeholder simply stops matching, silently, at one viewport width.
 *
 * The lists on the left, the figures on the right. The split is by *kind*: the main
 * column holds the two lists a reader acts on, the rail holds the three things that
 * describe the workspace rather than asking anything of it.
 */
export const OVERVIEW_GRID =
  'grid min-h-0 grid-cols-1 items-start gap-x-6 gap-y-5 lg:grid-cols-[minmax(0,1fr)_20rem]';

/** The main column inside that grid. */
export const OVERVIEW_MAIN_COLUMN = 'flex min-w-0 flex-col gap-5';
